var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// /var/www/html/wp-content/themes/sage/node_modules/simplebar/node_modules/core-js/internals/engine-is-node.js
// module id = 200
// module chunks = 0